<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "XiaofeiQianli",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    xy: {
      type: String,
      default: "x"
    },
    barWidth: {
      type: Number,
      default: 36
    },
    // unit: {
    //   type: String,
    //   default: ""
    // },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      var option = {
        grid: {
          // top: 20,
          bottom: 0,
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}"
        },

        calculable: true,
        xAxis: {
          type: "category",
          // axisTick: {
          //     show: false
          // },
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
          },
          data: this.chartData.nameList
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#414f5a",
              type: "dashed"
            }
          },
          axisLabel: {
            textStyle: {
              color: "#fff"
            }
            // formatter: value => {
            //     return value + this.unit;
            // }
          }
        },
        series: [
          {
            data: this.chartData.data,
            type: "bar",
            markPoint: {
              data: [
                // {name : '年最高', value : 182.2, xAxis: 7, yAxis: 183},
                // {name : '年最低', value : 2.3, xAxis: 11, yAxis: 3}
                // { name: "年最高", value: 9.6 },
                // { name: "年最低", value: 6.6 }
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }]
            },
            barWidth: this.barWidth,
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: "#60C4C7",
                label: {
                  show: true
                  // position: this.xy == "x" ? "top" : "right",
                  // formatter: params => {
                  //   var total = 0;
                  //   this.chartData.data.forEach(el => {
                  //     total += parseInt(el);
                  //   });
                  //   return Math.round((params.value / total) * 100) + "%";
                  // }
                }
              }
            }
          }
        ]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
